<div *ngIf="showDivider" class="dln-dt-timer-divider" aria-hidden="true"></div>

<label class="dln-dt-timer-content">
    <input class="dln-dt-timer-input" maxlength="2"
           [value]="displayValue | numberFixedLen : 2"
           (input)="handleInputChange(valueInput.value)" #valueInput>
</label>
<div class="actions">
    <button class="dln-dt-control-button dln-dt-control-arrow-button"
            type="button" tabindex="0"
            [disabled]="upBtnDisabled || value >= max"
            [attr.aria-label]="upBtnAriaLabel"
            (click)="upBtnClicked()">
    <span class="dln-dt-control-button-content" tabindex="-1">
        <i class="icon-chevron-up"></i>
    </span>
    </button>
    <button class="dln-dt-control-button dln-dt-control-arrow-button"
            type="button" tabindex="0"
            [disabled]="downBtnDisabled || value <= min"
            [attr.aria-label]="downBtnAriaLabel"
            (click)="downBtnClicked()">
    <span class="dln-dt-control-button-content" tabindex="-1">
        <i class="icon-chevron-down"></i>
    </span>
    </button>
</div>

